import useEventListener from '@repo-level/core-front/hooks/eventListener';
import type { RefObject } from 'react';

type Handler = (event: Event) => void;

export function useOnClickOutside<T extends HTMLElement = HTMLElement>(
  ref: RefObject<T>,
  handler?: Handler,
  mouseEvent: 'mousedown' | 'mouseup' | 'touchstart' = 'mousedown'
): void {
  useEventListener(mouseEvent, (event) => {
    const el = ref?.current;
    if (!el || el.contains(event.target as Node)) {
      return;
    }

    handler && handler(event);
  });
}
